<div class="preferences__content-wrapper card__wrapper">

  <mat-card appearance="outlined" class="flex-fill">
    <mat-card-title>
      <h1>Update Preferences</h1>
    </mat-card-title>
    <mat-card-content class="updates__history-list-wrapper">

      <div class="preferences__section-main">
        <form (ngSubmit)="updatePreferences()"   >

          <mat-form-field class="flex-fill" appearance="outline">
            <mat-label>How often do you wish to receive notifications of new updates?</mat-label>
            <mat-select name="notification_frequency" [(ngModel)]="notificationFrequency" #role="ngModel">
              <mat-option value="weekly">Weekly</mat-option>
              <mat-option value="monthly">Monthly</mat-option>
              <mat-option value="never">Never</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="flex-fill" appearance="outline">
            <mat-label>Which sections would you like to receive notifications for?</mat-label>
            <mat-select name="notification_sections" [(ngModel)]="selectedNotificationSectionIds" multiple (selectionChange)="onNotificationSectionChange($event)" panelClass="tall-dropdown-panel">
              <mat-select-trigger>
                {{getSectionDisplayText()}}
              </mat-select-trigger>
              <mat-option [value]="0">All sections</mat-option>
              <ng-container *ngFor="let section of availableSections">
                <!-- Parent sections -->
                <mat-option *ngIf="!section.parent_id" [value]="section.id">
                  {{section.name}}
                </mat-option>
                <!-- Child sections - indented -->
                <mat-option *ngIf="section.parent_id && section.can_report" [value]="section.id"
                  class="section-child-option">
                  {{section.name}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>

          <app-country-multi-select
            [countries]="availableCountries"
            [label]="'Which countries would you like to receive notifications for?'"
            [(ngModel)]="selectedNotificationCountries"
            name="notification_countries">
          </app-country-multi-select>

          <div class="preferences__button-wrapper">
            <a mat-flat-button color="accent" (click)="updatePreferences()" type="submit" class="submit-button">Update Preferences</a>
          </div>
          <div *ngIf="error" class="preferences__error-wrapper">
            <mat-error><div >{{error}}</div></mat-error>
          </div>
          <div *ngIf="message">{{message}}</div>
        </form>
      </div>

    </mat-card-content>
  </mat-card>
</div>
